module.exports = require('./helpers/bundle-url').getBundleURL('l9LCA') + "logo-dark.ba5147f0.svg";